import {unsafeCSS} from 'lit';
// @ts-ignore
import perfectScrollbarStyle from 'perfect-scrollbar/css/perfect-scrollbar.css?raw';

// language=CSS
export const perfectScrollbar =
    unsafeCSS(perfectScrollbarStyle);
